import store from '@/core/store'
import {actionTypes} from '@/core/constants'

class BuscarParametrosDoSistemaListener {
	async execute() {
		return store.dispatch(actionTypes.COMUM.BUSCAR_PARAMETROS_SISTEMA)
	}
}

export default new BuscarParametrosDoSistemaListener()
